import { EntityLink } from 'rfa-react-core';
import PropTypes from 'prop-types';
import React from 'react';
import { truncateOnWordBoundary } from 'app/utilities/truncate';
import { metaTime, publishedTime } from 'app/utilities/date-time';

const CHARACTER_LIMIT = {
    TITLE: 80
};

// Image above, then the title with the author and date on opposite ends of the
// bottom row. Stretches to whatever height its container gives it.
const StoryCard = ({ item }) => {
    const {
        author,
        name,
        publish_at: publishDate,
        thumbnail
    } = item.data;

    return (
        <article className="story-card">
            <EntityLink
                item={item}
                promoterBuName="Auckland Zoo"
                className="story-card-link"
            >
                {/*
                    An element rather than a background, so the thumbnail is a
                    thing on the page: image search can index it, it carries the
                    headline as its description, and the browser can hold it back
                    until it is scrolled to. A background image is none of those.

                    The placeholder keeps the card's shape when an article has no
                    thumbnail, which the fixed height would otherwise collapse.
                */}
                {thumbnail ?
                    <img
                        className="story-card-image"
                        src={thumbnail}
                        alt={name}
                        loading="lazy"
                        decoding="async"
                    /> :
                    <div className="story-card-image is-placeholder" />
                }
                <div className="story-card-content">
                    <h3 className="title">{truncateOnWordBoundary(name, CHARACTER_LIMIT.TITLE)}</h3>
                    <p className="meta">
                        {author && <span className="author">by {author}</span>}
                        {publishDate &&
                            <time className="date" dateTime={metaTime(publishDate)}>
                                {publishedTime(publishDate)}
                            </time>
                        }
                    </p>
                </div>
            </EntityLink>
        </article>
    );
};

StoryCard.propTypes = {
    item: PropTypes.object.isRequired
};

export default StoryCard;
